/**
 * Player head images from a public skin service (default mc-heads.net, looked up by player name),
 * configurable at build time with VITE_SKIN_URL (placeholders {uuid}, {name}, {size}) and per
 * browser in the settings. Lookup by name also works on offline-mode servers: the head shown is the
 * premium account with that name. A {uuid} template skips offline-mode UUIDs (no real skin), and the
 * generated pixel head is used instead.
 */
export const DEFAULT_SKIN_URL = 'https://mc-heads.net/avatar/{name}/{size}';

export function skinTemplate(): string | null {
  const env = (import.meta.env?.VITE_SKIN_URL as string | undefined) ?? undefined;
  if (env === '' || env === 'off') return null;
  return env ?? DEFAULT_SKIN_URL;
}

/** True for offline-mode UUIDs (`OfflinePlayer:<name>` -> UUID v3). */
export function isOfflineUuid(uuid: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-3/i.test(uuid);
}

export function skinUrl(
  uuid: string,
  name: string | null,
  size: number,
  template: string | null = skinTemplate(),
): string | null {
  if (!template) return null;
  if (template.includes('{name}') && !name) return null;
  if (template.includes('{uuid}') && isOfflineUuid(uuid)) return null;
  return template
    .replace('{uuid}', encodeURIComponent(uuid.replace(/-/g, '')))
    .replace('{name}', encodeURIComponent(name ?? ''))
    .replace('{size}', String(size));
}
